import { render } from "./CarteFoodtruck.vue?vue&type=template&id=50d96b62&scoped=true"
import script from "./CarteFoodtruck.vue?vue&type=script&lang=js"
export * from "./CarteFoodtruck.vue?vue&type=script&lang=js"

import "./CarteFoodtruck.vue?vue&type=style&index=0&id=50d96b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d96b62"]])

export default __exports__